import { del, get, post } from './core';

export function subscribeToDirector(directorId: string): Promise<{ ok: boolean }> {
  return post(`/directors/${directorId}/subscribe`);
}

export function unsubscribeFromDirector(directorId: string): Promise<{ ok: boolean }> {
  return del(`/directors/${directorId}/subscribe`);
}

export function getMySubscription(directorId: string): Promise<{ subscribed: boolean }> {
  return get(`/directors/${directorId}/my-subscription`);
}
